module.exports = __webpack_public_path__ + "img/177-colombia.563d3f15.svg";